<template lang="pug">
  v-container(fluid)
    DrivingSchoolList(
      v-if="schools"
      :list="drivingSchools"
      :total_count="schools.total_count"
      :total_paid="schools.total_paid"
      :loading="loading"
      @search="search"
      @needToUpdate="getDrivingSchoolList"
      @remove="removeSchool"
    )

</template>

<script>
import DrivingSchoolList from './components/DrivingSchoolList.vue'
import { DrivingSchoolList as DrivingSchoolListModel }   from './core/models/driving-school-list'
import { DrivingSchoolService } from './core/driving-school.service'
import ErrorMixin from "@/mixins/errors.mixin"
import { fields } from './core/const'

export default {
  mixins: [ ErrorMixin ],
  components: {
    DrivingSchoolList,
  },
  data: () => ({
    searchValue: '',
    schools: new DrivingSchoolListModel(),
    svc: null,
    loading: false,
  }),
  mounted() {
    this.init()
  },
  computed: {
    drivingSchools() {
      if (this.schools.items && this.schools.items.length) {
        return this.schools.items.filter(item => item[fields.DRIVING_SCHOOL].toLowerCase().includes(this.searchValue.toLowerCase()))
      } else {
        return []
      }
    }
  },
  methods: {
    async init() {
      this.svc = new DrivingSchoolService()
      await this.getDrivingSchoolList()
    },
    async getDrivingSchoolList() {
      this.loading = true;
      try {
        this.schools = await this.svc.list()
      } catch (err) {
        this.processError(err);
      } finally {
        this.loading = false;
      }
    },
    search(value) {
      this.searchValue = value;
    },

    removeSchool(id) {
      let removedSchoolIndex = this.schools.items.findIndex(item => item.id === id)
      this.schools.items.splice(removedSchoolIndex, 1)
    }
  }
}
</script>